let serverAddress=''
export default {
  // 服务器地址
  serverAddress: '',
  
  // 登录标识
  hasLogin: 'hasLogin',
  // 接口地址
  INTERFACE_LIST: {
    // 资讯详情
    getInformationDetails: 'website/chengduoduo-api/info/detail',
    // 资讯列表
    getInformationList: 'website/chengduoduo-api/info/list',
    // 企业旅游需求
    travelDemand: 'website/chengduoduo-api/info/travel/demand',
    // 资讯类型
    getInformationTypeList: 'website/chengduoduo-api/info/type/list',
    // 获取总条数
    getTypeNum:'website/chengduoduo-api/info/type/num'
  }
}
  switch (process.env.NODE_ENV){
    case 'fat':
       serverAddress='http://www.fat.qa.chengduoduo.com/';
       break
    case 'uat':
       serverAddress='http://www.uat.qa.chengduoduo.com/';
       break
    case 'prd':
       serverAddress='https://agent.chengduoduo.com/';
       break
  }



// WEBPACK FOOTER //
// ./common/constants.js